import { render, staticRenderFns } from "./Whole_Sev_naclodnoy.vue?vue&type=template&id=1015e1d7&"
import script from "./Whole_Sev_naclodnoy.vue?vue&type=script&lang=js&"
export * from "./Whole_Sev_naclodnoy.vue?vue&type=script&lang=js&"
import style0 from "./Whole_Sev_naclodnoy.vue?vue&type=style&index=0&id=1015e1d7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports